import { CAMPAIGN_TYPE } from "V2.0/HomePages/HomeCampaign/SingleCampaignAdd";
import {
  CALL_STAT_COLUMNS,
  CALL_ROW_GRID_COLS,
  CALL_ROW_MIN_WIDTH,
} from "V2.0/HomePages/Campaigns/BulkCampaigns/BulkCampaign/Components/Columns/Call.jsx";
import {
  CHAT_STAT_COLUMNS,
  CHAT_ROW_GRID_COLS,
  CHAT_ROW_MIN_WIDTH,
} from "V2.0/HomePages/Campaigns/BulkCampaigns/BulkCampaign/Components/Columns/Chat.jsx";
// NOTE: Frontend also has an EMAIL entry here (sourced from Components/Columns/Email.jsx),
// but this port deliberately drops it — Catalyst's CAMPAIGN_TYPE has no EMAIL value and the
// create flow (Task 8) has no way to create an Email bulk campaign, so there is nothing for
// an Email entry in this config to ever be looked up by. See task-4-brief.md Step 2.

export const BULK_CAMPAIGN_TABLE_CONFIG = {
  [CAMPAIGN_TYPE.CALL]: {
    columns: CALL_STAT_COLUMNS,
    gridCols: CALL_ROW_GRID_COLS,
    minWidth: CALL_ROW_MIN_WIDTH,
  },
  [CAMPAIGN_TYPE.SMS]: {
    columns: CHAT_STAT_COLUMNS,
    gridCols: CHAT_ROW_GRID_COLS,
    minWidth: CHAT_ROW_MIN_WIDTH,
  },
  [CAMPAIGN_TYPE.WHATSAPP]: {
    columns: CHAT_STAT_COLUMNS,
    gridCols: CHAT_ROW_GRID_COLS,
    minWidth: CHAT_ROW_MIN_WIDTH,
  },
};

export default function BulkCampaignTableHeader({ campaignType }) {
  const config = BULK_CAMPAIGN_TABLE_CONFIG[campaignType];
  if (!config) return null;

  return (
    <div
      className={`grid ${config.gridCols} items-center gap-x-4 px-4 py-3 bg-gray-50 border-b border-zinc-200 sticky top-0 z-10`}
    >
      <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">
        Campaign
      </p>
      {config.columns.map((col) => (
        <p
          key={col.headerLabel}
          className="text-xs font-medium text-gray-400 uppercase tracking-wide text-center"
        >
          {col.headerLabel}
        </p>
      ))}
      <p className="text-xs font-medium text-gray-400 uppercase tracking-wide text-right">
        Actions
      </p>
    </div>
  );
}
